module.exports = __webpack_public_path__ + "img/hero-getting-started-mobile@2x.98f9f9dc.png";